import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
import Nav from 'react-bootstrap/Nav';
import valPer from '../Tools/VerificarPermisos';
import ConsultasComunes from '../Sql/ConsultasComunes';
import DateConverter from '../Tools/DateConverter';
import { ContextGloball } from '../Context/ContextGlobal';
import UtilsBufer from '../Tools/UtilsBufer';
import RegistroFormulario from './RegistroFormulario';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import '../css/DirectorioColaborador.css'
const server = process.env.REACT_APP_SERVER;

function DirectorioColaborador() {
    const { setLoading } = useContext(ContextGloball);
    const [colaboradores, setColaboradores] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [idSucursal, setIdsucursal] = useState(-1);
    const [asegurado, setAsegurado] = useState('*');
    const [showModal, setShowModal] = useState(false);
    const [showModalVacunas, setShowModalVacunas] = useState(false);
    const [showModalAdjuntoBaja, setShowModalAdjuntoBaja] = useState(false);
    const [selectColaborador, setSelectColaborador] = useState(null);
    const [ventanaModal, setVentanaModal] = useState(0);
    const [showModalActualizarVacunas, setShowModalActualizarVacunas] = useState(false);
    const [nombreBuscado, setNombreBuscado] = useState(null);
    const [idDepartamento, setIdDepartamento] = useState(-1);
    const [actualizar, setActualizar] = useState(false);
    const [departamentos, setDepartamentos] = useState([]);
    const [idCargo, setIdCargo] = useState(0);
    const [cargos, setCargos] = useState([]);
    const [idEstado, setIdEstado] = useState(0);
    const [estado, setEstado] = useState('A');
    const [estadoBaja, setEstadoBaja] = useState('*');
    const [idContrato, setIdContrato] = useState('*');
    const [idRegional, setIdRegional] = useState('');
    const [esLimitado, setEsLimitado] = useState(false);
    const [idTurno, setIdTurno] = useState('*');

    const [tipoVacuna, setTipoVacuna] = useState('*');
    const [tipoBajaMedica, setTipoBajaMedica] = useState('*');
    const [estadoBajaMedica, setEstadoBajaMedica] = useState('*');
    const [idColaborador, setIdClaborador] = useState(0);

    const [tipoVacunaForm, setTipoVacunaForm] = useState('C');
    const [numDosisForm, setNumDosisForm] = useState(1);
    const [fechaVacuna, setFechaVacuna] = useState("");
    const [observaciones, setObservaciones] = useState('');
    const [contadorIdNuevaVacuna, setContadorIduevaVacuna] = useState(0);
    const [errores, setErrores] = useState({});
    const [erroresActualizar, setErroresActualizar] = useState({});

    const [imagenURL, setImagenURL] = useState(null);
    const [pdfURL, setPdfURL] = useState(null);
    const [docxURL, setDocxURL] = useState(null);

    const [tipoVacunaFormActualizar, setTipoVacunaFormActualizar] = useState('');
    const [numDosisFormActualizar, setNumDosisFormActualizar] = useState(0);
    const [fechaVacunaActualizar, setFechaVacunaActualizar] = useState('');
    const [observacionesActualizar, setObservacionesActualizar] = useState('');
    const [idEmpleadoActualizar, setIdEmpleadoActualizar] = useState(0);
    const [vacunaActualizar, setVacunaActualizar] = useState(null);

    async function actualizarVacuna() {
        try {
            var response = await fetch(`${server}/formulario/updateVacuna`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': idRegional, 
                    'id_empleado': idEmpleadoActualizar, 'id_vacuna': vacunaActualizar.ID_VACUNA, 
                    'tipoVacunaForm': tipoVacunaFormActualizar, 'numDosisForm': numDosisFormActualizar, 
                    'fechaVacuna': fechaVacunaActualizar, 'observaciones': observacionesActualizar, 
                })
            });
            if (response.ok) {
                let data = await response.json();
                console.log(data)
                MsgUtils.msgCorrecto("Vacuna actualizada correctamente. Refresque la pagina para visualizar los cambios");
                setShowModalActualizarVacunas(false)
            }else{
                
                setLoading(false);
                console.log("No se pudo obtener la ruta")
                MsgUtils.msgError("No se pudo actualizar los datos del colaborador");
            }
        } catch (networkError) {
            MsgUtils.msgError("No se pudo conectar con la base de datos: " + networkError.message);
            console.error("Error en fetch:", networkError);
        }
        

    }

    async function getAdjuntosBajasMedicas(indice) {
        let data;
        setLoading(true);
        try {
            var response = await fetch(`${server}/formulario/getAdjuntosBajasMedicas`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': idRegional,
                    'id_baja': selectColaborador.BAJAS_MEDICAS[indice].ID_BAJA
                })
            });
            if (response.ok) {
                data = await response.json();

                if(data.ok[0].RUTA){
                    console.log(data.ok[0].RUTA);
                    setLoading(false);
                }else{
                    setLoading(false);
                    MsgUtils.msgAdvertencia("Baja Medica Sin Adjunto.");
                    return
                }
            }else{
                
                setLoading(false);
                console.log("No se pudo obtener la ruta")
                MsgUtils.msgError("No se pudo obtener el adjunto");
            }
        } catch (networkError) {
            MsgUtils.msgError("Baja Medica sin Adjunto: " + networkError.message);
            console.error("Error en fetch:", networkError);
        }

        setLoading(true);

        if (data && data.ok && data.ok[0].RUTA) {

            let url = obtenerNombreArchivo(data.ok[0].RUTA);
            console.log(url);
            let url1 = generarURL(url); 
            console.log("URL generada:", url1);
            try {
                const axiosResponse = await axios.get(url1, { responseType: 'blob' });
                const contentType = axiosResponse.headers['content-type']; 
                console.log(contentType);

                const imageBlob = new Blob([axiosResponse.data], { type: contentType });
                const imageUrl = URL.createObjectURL(imageBlob);
                console.log()
                if (contentType.startsWith('image/')) {
                    console.log("Es imagen")
                    setImagenURL(imageUrl);
                    setShowModalAdjuntoBaja(true);
                } else if (contentType === 'application/pdf') {
                    console.log("Es pdf")
                    setPdfURL(imageUrl)
                    setShowModalAdjuntoBaja(true);
                } else if(contentType === 'application/octet-stream'){
                    console.log("Es un archivo docx");
                    MsgUtils.msgCorrecto("Su archivo docx se descargará en breve.");
                    descargarArchivoDoc(imageUrl, 'documento.docx');
                }else {
                    console.error('Tipo de archivo no soportado:', contentType);
                    MsgUtils.msgError("Tipo de archivo no soportado.");
                }

                console.log(imageUrl);
                setLoading(false);
                
            } catch (axiosError) {
                setLoading(false);
                console.error('Error al obtener el archivo:', axiosError);
                MsgUtils.msgError("El adjunto que busca ya no existe en el servidor");
            }
            
        } else {
            console.log("No se pudo obtener la ruta del archivo.");
        }
    }

    function descargarArchivoDoc(url, nombreArchivo) {
        const link = document.createElement('a');
        link.href = url;
        link.download = nombreArchivo;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function obtenerNombreArchivo(ruta){
        console.log(ruta);
        return String(ruta).split("\\").pop();
    }

    function generarURL(nombreArchivo) {
        const regex = /^([A-Z]+)_0*(\d+)\.(\w+)$/i;
        const match = nombreArchivo.match(regex);
        if (!match) return null; 

        const tipo = match[1];   
        const adjid = match[2];  
        const ext = match[3].toUpperCase(); 

        console.log(idRegional);

        if(idRegional == 990){
            console.log("CBBA")
            return `https://archivos.chickenskingdom.com/?tipo=${tipo}&adjid=${adjid}&ext=${ext}`;
        }else{
            console.log("SCZ")
            return `https://ra.chickenskingdom.com/?tipo=${tipo}&adjid=${adjid}&ext=${ext}`;
        }
    }
    
    function addVacuna() {
        setLoading(true);
        fetch(`${server}/formulario/addVacuna`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'regional': idRegional,
                'id_vacuna': selectColaborador.NUM_VACUNAS[0].NUM_VACUNAS + 1 + contadorIdNuevaVacuna, 'id_empleado': selectColaborador.ID_EMPLEADO,
                tipoVacunaForm, fechaVacuna, numDosisForm, observaciones, idRegional
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setLoading(false);
                if (data.ok) {
                    console.log("Vacuna Registrada")
                    aumentarContadorIdNuevaVacuna();
                    MsgUtils.msgCorrecto("Vacuna registrada correctamente. Refresque la pagina para visualizar los cambios");
                    setShowModalVacunas(false);
                } else {
                    console.log("No se pudo registrar")
                    MsgUtils.msgError("No se pudo registrar la vacuna.");
                    //MsgUtils.msgError(data.error);
                }
            })
            .catch(err => MsgUtils.msgError(err));

    }

    const getDirectorioColaborador = async () => {
        setLoading(true);
        try {
            var directorio = await ConsultasComunes.getCatalogoColaborador({
                "regional": idRegional,
                "idPerfil": -100,
                "estado": estado,
                "estadoBaja": estadoBaja, idCargo, idTurno, idContrato,
                nombreBuscado, idDepartamento, idSucursal, asegurado, tipoVacuna, estadoBajaMedica, tipoBajaMedica
            })

            if (directorio.ok) {
                setColaboradores(directorio.ok);
                console.log(directorio)
                console.log(directorio.ok)
            } else {
                MsgUtils.msgError(directorio.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        } finally {
            setLoading(false);
        }
    }
    const getSucursales = async (regional) => {
        try {
            var sucursales = await ConsultasComunes.getSucursales(regional);
            if (sucursales.ok) {
                setSucursales(sucursales.ok);
            } else {
                MsgUtils.msgError(sucursales.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        }
    }
    function getAntiguedad(valor) {
        var valorFinal = ''
        var años = parseInt(valor / 12)
        if (años > 0) {
            valorFinal = valorFinal + años + ' A'
        }
        var meses = parseInt(valor % 12)
        if (meses > 0) {
            valorFinal = valorFinal + ' ' + meses + ' m'
        }
        if (años <= 0 && meses <= 0) {
            valorFinal = parseInt(valor * 100) + ' d'
        }
        return valorFinal
    }
    const getCargos = async (regional) => {
        try {
            var cargos = await ConsultasComunes.getInfoCategoriasSys({ 'regional': regional, 'tipo': 'TC' });
            if (cargos.ok) {
                setCargos(cargos.ok);
            } else {
                MsgUtils.msgError(cargos.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        }
    }
    const getDepartamentos = async (regional) => {
        try {
            var departament = await ConsultasComunes.getInfoCategoriasSys({ 'regional': regional, 'tipo': 'DE' });
            if (departament.ok) {
                setDepartamentos(departament.ok);
            } else {
                MsgUtils.msgError(departament.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        }
    }
    const getInfoColaborador = async (colaborador) => {
        try {
            //var infoUser = JSON.parse(localStorage.getItem('__react_session__'));
            var infoColaborador = await ConsultasComunes.getInfoColaborador({ 'regional': idRegional, 'idEmpleado': colaborador.ID_EMPLEADO })
            //var infoColaborador = await ConsultasComunes.getInfoColaborador({ 'regional': infoUser.regional, 'idEmpleado': colaborador.ID_EMPLEADO })
            if (infoColaborador.ok) {
                console.log(infoColaborador.ok);
                setIdClaborador(infoColaborador.ok.ID_EMPLEADO);
                setSelectColaborador({ ...infoColaborador.ok[0], 'AUX': colaborador });
                setShowModal(true);

            } else {
                MsgUtils.msgError(infoColaborador.error);
                setShowModal(false);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
            setShowModal(false);
        }
    }
    function cambiarDeEstado(valor) {
        setIdEstado(valor);
        if (valor == 5) {
            setEstado('*');
            setEstadoBaja('*');
        } else if (valor == 4) {
            setEstado('I');
            setEstadoBaja('*');
        } else {
            setEstado('A')
            switch (valor) {
                case 0:
                    setEstadoBaja('*');
                    break;
                case 1:
                    setEstadoBaja('N');
                    break;
                case 2:
                    setEstadoBaja('F');
                    break;
                case 3:
                    setEstadoBaja('P');
                    break;
            }
        }
        setActualizar(!actualizar);
    }
    const cambiarDeRegional = (valor) => {
        setIdRegional(valor);
        getSucursales(valor)
        getDepartamentos(valor)
        getCargos(valor)
        setColaboradores([]);
    }

    function abrirFormularioVacuna() {
        setShowModalVacunas(true);
    }

    function handleSubmitVacuna(e) {
        e.preventDefault();

        const validacionErrores = {};

        if (!fechaVacuna) {
            validacionErrores.fechaVacuna = "Debe seleccionar una fecha de vacuna";
        }

        setErrores(validacionErrores);
        if (Object.keys(validacionErrores).length === 0) {
            addVacuna();
        }
    }

    function abrirAdjuntoBaja(indice) {
        getAdjuntosBajasMedicas(indice);
    }

    useEffect(() => {
        getDirectorioColaborador();
    }, [actualizar])
    useEffect(() => {
        var infoUser = JSON.parse(localStorage.getItem('__react_session__'));
        if (idRegional == '') {
            setIdRegional(infoUser.regional)
            getSucursales(infoUser.regional)
            getDepartamentos(infoUser.regional)
            getCargos(infoUser.regional)
            if (valPer.validarPermiso('66') == true && valPer.validarPermiso('0') == false) {//tiene permiso a directorio para supervisores
                setEsLimitado(true);
                setIdsucursal(infoUser.empresaSucursal);
                setVentanaModal(4)
            } else {
                setEsLimitado(false);
            }
        }
    }, [])

    const mostrarVacuna = (tipoVacuna) => {

        switch (tipoVacuna) {
            case '\u0000C': return 'COVID';
            case '\u0000A': return 'Fiebre Amarilla';
            case '\u0000T': return 'Tétanos';
            case '\u0000O': return 'Otro';
            default: return 'Seleccione vacuna';
        }
    };

    function mostrarTipoBajaMedica(){

        if(tipoBajaMedica === '*') {
            return 'Seleccione Baja Medica';
        }else{
            return tipoBajaMedica;
        }
    }

    const aumentarContadorIdNuevaVacuna = () => {
        setContadorIduevaVacuna(contadorIdNuevaVacuna => contadorIdNuevaVacuna + 1);
    };

    function cerrarFormularioVacunas(){
        setShowModalVacunas(false)
        setFechaVacuna('');
        setObservaciones('');
        setNumDosisForm(1);
        setTipoVacunaForm('C');
        setErrores({});
    }

    function cerrarModalAdjunto(){
        if (imagenURL) {
            URL.revokeObjectURL(imagenURL); 
            setImagenURL(null); 
          }
          if (pdfURL) {
            URL.revokeObjectURL(pdfURL); 
            setPdfURL(null); 
          }
        
        setShowModalAdjuntoBaja(false);
    }

    function setActualizarVacuna(id_empleado, vacuna){
        setTipoVacunaFormActualizar(vacuna.TIPO_VACUNA);
        setNumDosisFormActualizar(vacuna.NUM_DOSIS);

        const fechaCompleta = vacuna.FECHA;
        const soloFecha = fechaCompleta.split("T")[0];
        console.log(soloFecha)

        setFechaVacunaActualizar(soloFecha);
        console.log(UtilsBufer.getText(vacuna.OBSERVACIONES))
        setObservacionesActualizar(UtilsBufer.getText(vacuna.OBSERVACIONES));
        setShowModalActualizarVacunas(true);

        setIdEmpleadoActualizar(id_empleado);
        setVacunaActualizar(vacuna);
        //setErrores({});
    }

    function handleSubmitVacunaActualizar(e) {

        e.preventDefault();

        actualizarVacuna();

        /*
        
        const validacionErrores = {};

        if (!fechaVacuna) {
            validacionErrores.fechaVacuna = "Debe seleccionar una fecha de vacuna";
        }

        setErroresActualizar(validacionErrores);
        if (Object.keys(validacionErrores).length === 0) {
            actualizarVacuna();
        }
        
        */

        
    }

    function cerrarFormularioVacunasActualizar(){
        setShowModalActualizarVacunas(false)
        //setFechaVacuna('');
        //setObservaciones('');
        //setNumDosisForm(1);
        //setTipoVacunaForm('C');
        //setErrores({});
    }

    return (
        <>
            <div className='container-fluid bg-dark py-1'>
                <div className='row row-cols gx-1'>
                    <div className='col' style={{ minWidth: "150px", maxWidth: "150px" }}>
                        <div className=''>
                            <div className="small fw-light text-white">Sucursal</div>
                            <select className='form-select form-select-sm' value={idSucursal}
                                disabled={esLimitado == true ? true : false}
                                onChange={(e) => { setIdsucursal(parseInt(e.target.value)); setActualizar(!actualizar); }}>
                                <option value="-1">Todas</option>
                                {sucursales.map((sucursal, index) => (
                                    <option key={index} value={sucursal.ID_SUCURSAL}>{sucursal.SUCURSAL}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col" style={{ minWidth: '250px', maxWidth: '250px' }}>
                        <div className="small fw-light text-white">Buscar</div>
                        <div className="input-group input-group-sm">
                            <input className="form-control form-control-sm"
                                placeholder='COLABORADOR'
                                type="text"
                                value={nombreBuscado}
                                onChange={(e) => { setNombreBuscado(e.target.value.toUpperCase()); setActualizar(!actualizar) }} />
                        </div>
                    </div>
                    {esLimitado == false && <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Departamento</div>
                        <select className='form-select form-select-sm'
                            value={idDepartamento}
                            onChange={(e) => { setIdDepartamento(parseInt(e.target.value)); setActualizar(!actualizar) }}>
                            <option value="-1">--TODOS--</option>
                            {departamentos.map((departamento, index) => {
                                return (
                                    <option value={departamento.ID_CATEGORIA} key={index}>{departamento.CATEGORIA}</option>
                                )
                            })}
                        </select>
                    </div>}
                    {esLimitado == false && <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Cargo</div>
                        <select className='form-select form-select-sm'
                            value={idCargo}
                            onChange={(e) => { setIdCargo(parseInt(e.target.value)); setActualizar(!actualizar) }}>
                            <option value="0">-CUALQUIERA-</option>
                            {cargos.map((cargo, index) => {
                                return (
                                    <option value={cargo.ID_CATEGORIA} key={index}>{cargo.CATEGORIA}</option>
                                )
                            })}
                        </select>
                    </div>}
                    {esLimitado == false && <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Estado</div>
                        <select className='form-select form-select-sm'
                            value={idEstado}
                            onChange={(e) => { cambiarDeEstado(parseInt(e.target.value)); }}>
                            <option value="0">Activos(incl. Bajas en Proceso)</option>
                            <option value="1">Activos Sin Bajas en Programada</option>
                            <option value="2">Con Baja Programada</option>
                            <option value="3">Con Baja en Proceso</option>
                            <option value="4">Con Baja Finalizada</option>
                            <option value="5">Cualquier Estado</option>
                        </select>
                    </div>}
                    {esLimitado == false && <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Contrato</div>
                        <select className='form-select form-select-sm'
                            value={idContrato}
                            onChange={(e) => { setIdContrato(e.target.value); setActualizar(!actualizar) }}>
                            <option value="*">-Cualquiera-</option>
                            <option value="KIN">Indefinido</option>
                            <option value="PDE">Plan Desarrollo de Empleo</option>
                            <option value="PAE">PAE</option>
                            <option value="LIM">Pagos por Dia</option>
                            <option value="TEM">Contrato 89 días</option>
                            <option value="REC">Receso</option>
                        </select>
                    </div>}
                    {esLimitado == false && <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Asegurado</div>
                        <select className='form-select form-select-sm'
                            value={asegurado}
                            onChange={(e) => { setAsegurado(e.target.value); setActualizar(!actualizar) }}>
                            <option value="*">Todos</option>
                            <option value="S">Si</option>
                            <option value="N">No</option>
                        </select>
                    </div>}
                    {esLimitado == false && <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Turno</div>
                        <select className='form-select form-select-sm'
                            value={idTurno}
                            onChange={(e) => { setIdTurno(e.target.value); setActualizar(!actualizar) }}>
                            <option value="*">-Cualquiera-</option>
                            <option value="M">Mañana</option>
                            <option value="N">Noche</option>
                            <option value="O">Partido</option>
                            <option value="Q">Corrido</option>
                            <option value="X">Sin Especificar</option>
                        </select>
                    </div>}
                    {esLimitado == false && <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Vacunas</div>
                        <select className='form-select form-select-sm'
                            value={tipoVacuna}
                            onChange={(e) => { setTipoVacuna(e.target.value); setActualizar(!actualizar) }}>
                            <option value="*">-Cualquiera-</option>
                            <option value="C">Covid</option>
                            <option value="A">Fiebre Amarilla</option>
                            <option value="T">Tetanos</option>
                            <option value="O">Otro</option>
                        </select>
                    </div>}

                    {esLimitado == false && idRegional == 990 && <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Baja Medica</div>
                        <select className='form-select form-select-sm'
                            value={tipoBajaMedica}
                            onChange={(e) => { setTipoBajaMedica(e.target.value); setActualizar(!actualizar) }}>
                            <option value="*">-Cualquiera-</option>
                            <option value="Enfermedad Común">Enfermedad Común</option>
                            <option value="Maternidad">Maternidad</option>
                            <option value="Riesgo Profesional">Riesgo Profesional</option>
                        </select>
                    </div>}


                    {esLimitado == false && idRegional == 991 && <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Baja Medica</div>
                        <select className='form-select form-select-sm'
                            value={tipoBajaMedica}
                            onChange={(e) => { setTipoBajaMedica(e.target.value); setActualizar(!actualizar) }}>
                            <option value="*">-Cualquiera-</option>
                            <option value="Problemas de Salud">Problemas de Salud</option>
                            <option value="Embarazo">Embarazo</option>
                            <option value="Accidente">Accidente</option>
                        </select>
                    </div>}

                    {valPer.validarPermiso(64) && <div className='col' style={{ minWidth: '120px', maxWidth: '120px' }}>
                        <div className='small fw-light text-white'>Regional</div>
                        <select className='form-select form-select-sm'
                            value={idRegional}
                            onChange={(e) => {cambiarDeRegional(e.target.value) ; setActualizar(!actualizar) }}>
                            <option value="990">CBBA</option>
                            <option value="991">SCRZ</option>
                        </select>
                    </div>}
                    <div className='col' style={{ minWidth: '50px', maxWidth: '50px' }}>
                        <div className='small fw-light text-white'>Cargar</div>
                        <button className='btn btn-sm btn-success w-100' onClick={() => setActualizar(!actualizar)}><i className="fa-solid fa-repeat"></i></button>
                    </div>
                </div>
            </div>
            <div className='container-fluid m-0 p-0'>
                <div className='table-responsive'>
                    <table className='table table-dark table-striped table-sm table-bordered' id="tablaColaboradores">
                        <thead>
                            <tr>
                                <th style={{ width: '50px' }}>ID</th>
                                <th style={{ width: '350px' }}>Nombre</th>
                                <th style={{ width: '10px' }}>Ge.</th>
                                <th style={{ width: '110px' }}>Fecha Nac.</th>
                                <th style={{ width: '200px' }}>Cargo</th>
                                <th style={{ width: '150px' }}>Sucursal</th>
                                <th style={{ width: '120px' }}>Turno</th>
                                <th style={{ width: '130px' }}>Contrato Actual</th>
                                <th style={{ width: '120px' }}>Fecha Ing.</th>
                                <th style={{ width: '100px' }}>Antig</th>
                                <th style={{ width: '120px' }}>Fecha Baja</th>
                                <th style={{ width: '120px' }}>Vacuna Contra</th>
                                <th style={{ width: '120px' }}>Cantidad Dosis </th>
                                <th style={{ width: '120px' }}>Tipo Baja Medica</th>
                                <th style={{ width: '120px' }}>Mas Informacion  </th>
                            </tr>
                        </thead>
                        <tbody>
                            {colaboradores.filter(colaborador => ((tipoVacuna === '*' || colaborador.NUMERO_DOSIS > 0)
                                && (tipoBajaMedica === '*' || colaborador.NUMERO_BAJA_MEDICA > 0) )

                            ).map((colaborador, index) => {
                                return (
                                    <tr key={index}>
                                        <td id={colaborador.EMPRESA_ASEGURADO}>{colaborador.ID_EMPLEADO}</td>
                                        <td>{colaborador.NOMBRE_COMPLETO}</td>
                                        <td>{colaborador.CARNET_SEXO}</td>
                                        <td>{DateConverter.formatoFechaSimple(colaborador.CARNET_NACIMIENTO)}</td>
                                        <td style={{ fontSize: '13px' }}>{colaborador.CARGO}</td>
                                        <td id={colaborador.EMPRESA_SUCURSAL} >{colaborador.SUCURSAL}</td>
                                        <td>{colaborador.TURNO}</td>
                                        <td style={{ fontSize: '13px' }}>{colaborador.NOMBRE_TIPO_CONTRATO}</td>
                                        <td>{DateConverter.formatoFechaSimple(colaborador.EMPRESA_FECHA_INGRESO)}</td>
                                        <td>{getAntiguedad(colaborador.ANTIGUEDAD)}</td>
                                        <td>{colaborador.FECHA_FINAL != null ? DateConverter.formatoFechaSimple(colaborador.FECHA_FINAL) : 'Indefinido'}</td>
                                        <td>{mostrarVacuna(colaborador.TIPO_VACUNA)}</td>
                                        <td>{colaborador.NUMERO_DOSIS}</td>
                                        <td>{mostrarTipoBajaMedica(colaborador.NUMERO_BAJA_MEDICA)}</td>
                                        <td>
                                            <button className='btn btn-sm btn-transparent text-light fs-5 m-0 p-0'
                                                onClick={() => getInfoColaborador(colaborador)}>
                                                <i className="fa-solid fa-ellipsis"></i></button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName='bg-dark bg-gradient'
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton closeVariant='white' className="d-flex align-items-center">
                    <Modal.Title bsPrefix='text-light' id="contained-modal-title-vcenter">
                        {selectColaborador != null && <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }} >
                            {UtilsBufer.getFotoCard(selectColaborador.FOTO, 40)}
                            <div className='ps-2 my-auto'>
                                <div className="cargoHeader fw-bold" id='buscareAqui'>{selectColaborador.NOMBRE_COMPLETO}</div>
                                <div className='cargoHeader '>{selectColaborador.SUCURSAL}</div>
                            </div>
                        </div>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Nav fill variant="tabs" onSelect={(selectedKey) => setVentanaModal(selectedKey)} activeKey={ventanaModal}>
                        {esLimitado == false && <Nav.Item bsPrefix='nav-item navItemBorder'>
                            <Nav.Link bsPrefix={`nav-link ${ventanaModal == 0 ? 'text-dark' : 'text-light'}`} eventKey={0}>Datos</Nav.Link>
                        </Nav.Item>}
                        {esLimitado == false && <Nav.Item bsPrefix='nav-item navItemBorder'>
                            <Nav.Link bsPrefix={`nav-link ${ventanaModal == 1 ? 'text-dark' : 'text-light'}`} eventKey={1}>Bajas Medicas</Nav.Link>
                        </Nav.Item>}
                        {valPer.validarPermiso('62') && <Nav.Item bsPrefix='nav-item navItemBorder'>
                            <Nav.Link bsPrefix={`nav-link ${ventanaModal == 2 ? 'text-dark' : 'text-light'}`} eventKey={2}>Formularios</Nav.Link>
                        </Nav.Item>}
                        {valPer.validarPermiso('63') && <Nav.Item bsPrefix='nav-item navItemBorder'>
                            <Nav.Link bsPrefix={`nav-link ${ventanaModal == 4 ? 'text-dark' : 'text-light'}`} eventKey={4}>Encuestas</Nav.Link>
                        </Nav.Item>}
                        {esLimitado == false && <Nav.Item bsPrefix='nav-item navItemBorder'>
                            <Nav.Link bsPrefix={`nav-link ${ventanaModal == 3 ? 'text-dark' : 'text-light'}`} eventKey={3}>
                                Vacunas
                            </Nav.Link>
                        </Nav.Item>}
                    </Nav>
                    {ventanaModal == 0 && selectColaborador != null &&
                        <div className='container-fluid' style={{ height: `${window.innerHeight - window.innerHeight * 0.3}px` }}>
                            <div className='text-light'>
                                <div className='fw-bold text-center'>Datos Personales</div>
                                <hr className='m-0 p-0 text-light'></hr>
                                <div>Nombre Completo: {selectColaborador.NOMBRE_COMPLETO}</div>
                                <div>Nro CI: {selectColaborador.CARNET_NRO} {selectColaborador.CARNET_EXP}</div>
                                <div>Genero: {selectColaborador.SEXO}</div>
                                <hr className='m-0 p-0 text-light'></hr>
                                <div className='fw-bold text-center'>Datos Laborales</div>
                                <hr className='m-0 p-0 text-light'></hr>
                                <div>Empresa: {selectColaborador.ID_EMPRESA == 1 ? "Chicken's kingdom Srl" : 'Kingtor'}</div>
                                <div>Cargo: {selectColaborador.CARGO}</div>
                                <div>Sucursal: {selectColaborador.SUCURSAL}</div>
                                <div>Turno: {selectColaborador.AUX.TURNO}</div>
                                <div>Contrato Actual: {selectColaborador.AUX.NOMBRE_TIPO_CONTRATO}</div>
                                <div>Fecha Ingreso: {DateConverter.formatoFechaNumeric(selectColaborador.EMPRESA_FECHA_INGRESO)}</div>
                                <div>Fecha Afilización: {DateConverter.formatoFechaNumeric(selectColaborador.EMPRESA_FECHA_AFILIACION)}</div>
                                <div>Carnet Sanitario: {DateConverter.formatoFechaNumeric(selectColaborador.CARNET_SANITARIO_FECHA)}</div>
                                <div>Carnet Seguro: {DateConverter.formatoFechaNumeric(selectColaborador.FECHA_SEGURO)}</div>
                            </div>
                        </div>}
                    {ventanaModal == 1 &&
                        <div className='container-fluid' style={{ height: `${window.innerHeight - window.innerHeight * 0.3}px` }}>
                            {selectColaborador.BAJAS_MEDICAS.length > 0 && <div className='table-responsive'>
                                <table className='table table-light table-striped table-hober'>
                                    <thead>
                                        <tr>
                                            <th>Desde Fecha</th>
                                            <th>Hasta Fecha</th>
                                            <th>Motivos</th>
                                            <th>Tipo</th>
                                            <th>Estado</th>
                                            <th>Observaciones</th>
                                            <th>Adjunto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectColaborador.BAJAS_MEDICAS.map((bajaMedica, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{DateConverter.formatoFechaNumeric(bajaMedica.FECHA_INICIO)}</td>
                                                    <td>{DateConverter.formatoFechaNumeric(bajaMedica.FECHA_FIN)}</td>
                                                    <td>{bajaMedica.CATEGORIA}</td>
                                                    <td>{bajaMedica.NOMBRE_TIPO}</td>
                                                    <td>{bajaMedica.NOMBRE_ESTADO}</td>
                                                    <td>{bajaMedica.OBSERVACIONES_CADENA}</td>
                                                    <td><button type='button'
                                                        className="btn btn-light"
                                                        onClick={() => abrirAdjuntoBaja(index)}>
                                                        <i className="fa-solid fa-eye"></i>
                                                    </button></td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>}
                        </div>}
                    {ventanaModal == 2 &&
                        <div style={{ height: `${window.innerHeight - window.innerHeight * 0.3}px` }}>
                            <RegistroFormulario selectColaborador={selectColaborador} regional={idRegional} tipo={ventanaModal == 2 ? 3 : 4} />
                        </div>}
                    {ventanaModal == 4 &&
                        <div style={{ height: `${window.innerHeight - window.innerHeight * 0.3}px` }}>
                            <RegistroFormulario selectColaborador={selectColaborador} regional={idRegional} tipo={ventanaModal == 2 ? 3 : 4} />
                        </div>}
                    {ventanaModal == 3 && selectColaborador != null &&
                        
                        <>
                        <div className="ms-auto text-end" style={{ minWidth: '50px', maxWidth: '80px' }}>
                            <button className='btn btn-sm btn-success w-100 mt-2 mb-2' onClick={() => abrirFormularioVacuna()}>
                                Registrar Vacuna
                            </button>
                        </div>
                        <div className='container-fluid' style={{ height: `${window.innerHeight - window.innerHeight * 0.3}px` }}>
                                <div className='table-responsive'>
                                    <table className='table table-light table-striped table-hober'>
                                        <thead>
                                            <tr>
                                                <th>Tipo</th>
                                                <th>Fecha</th>
                                                <th>Dosis</th>
                                                <th>Observaciones</th>
                                                <th>Actualizar</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectColaborador.VACUNAS.map((vacuna, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{vacuna.TIPO_VACUNA_T}</td>
                                                        <td>{DateConverter.formatoFechaNumeric(vacuna.FECHA)}</td>
                                                        <td>{vacuna.NUM_DOSIS}</td>
                                                        <td>{UtilsBufer.getText(vacuna.OBSERVACIONES)}</td>
                                                        <td><button className='btn btn-sm btn-warning' onClick={() => setActualizarVacuna(selectColaborador.ID_EMPLEADO, vacuna)}><i class="fa-solid fa-pen-to-square"></i></button></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div></>
                    }
                </Modal.Body>
            </Modal>

            <Modal show={showModalVacunas} onHide={() => cerrarFormularioVacunas()} backdrop="static"
                keyboard={false}>
                <Modal.Header className="text-center" closeButton>
                    <Modal.Title>Registrar Vacuna</Modal.Title>
                </Modal.Header>
                <Modal.Body><Form onSubmit={handleSubmitVacuna}>

                    <Form.Group className="mb-3">
                        <Form.Label>Tipo Vacuna</Form.Label>
                        <Form.Select onChange={(e) => { setTipoVacunaForm(e.target.value) }}>
                            <option value="C">Covid</option>
                            <option value="A">Fiebre Amarilla</option>
                            <option value="T">Tetanos</option>
                            <option value="O">Otro</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Nmo Dosis</Form.Label>
                        <Form.Select onChange={(e) => { setNumDosisForm(e.target.value) }}>
                            <option value={1}>Primera Dosis</option>
                            <option value={2}>Segunda Dosis</option>
                            <option value={3}>Tercera Dosis</option>
                            <option value={4}>Cuarta Dosis</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Selecciona una fecha:</Form.Label>
                        <Form.Control
                            type="date"
                            value={fechaVacuna}
                            onChange={(e) => {
                                setFechaVacuna(e.target.value);
                            }}
                        />
                        {errores.fechaVacuna && (
                        <div className="alert alert-danger bg-transparent border-0 text-danger m-0 p-0">
                          {errores.fechaVacuna}
                        </div>
                      )}
                    </Form.Group>

                    <Form.Group controlId="formNombre">
                        <Form.Label>Observaciones</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ingrese sus observaciones"
                            name="nombre"
                            value={observaciones}
                            onChange={(e) => { setObservaciones(e.target.value) }}
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit" className="mt-3">
                        Registrar
                    </Button>
                </Form></Modal.Body>
            </Modal>

            <Modal show={showModalActualizarVacunas} onHide={() => cerrarFormularioVacunasActualizar()} backdrop="static"
                keyboard={false}>
                <Modal.Header className="text-center" closeButton>
                    <Modal.Title>Actualizar Vacuna</Modal.Title>
                </Modal.Header>
                <Modal.Body><Form onSubmit={handleSubmitVacunaActualizar}>
                    <Form.Group className="mb-3">
                        <Form.Label>Tipo Vacuna</Form.Label>
                        <Form.Select value={tipoVacunaFormActualizar} onChange={(e) => { setTipoVacunaFormActualizar(e.target.value) }}>
                            <option value="C">Covid</option>
                            <option value="A">Fiebre Amarilla</option>
                            <option value="T">Tetanos</option>
                            <option value="O">Otro</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Nmo Dosis</Form.Label>
                        <Form.Select value={numDosisFormActualizar} onChange={(e) => { setNumDosisFormActualizar(e.target.value) }}>
                            <option value={1}>Primera Dosis</option>
                            <option value={2}>Segunda Dosis</option>
                            <option value={3}>Tercera Dosis</option>
                            <option value={4}>Cuarta Dosis</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Selecciona una fecha:</Form.Label>
                        <Form.Control
                            type="date"
                            value={fechaVacunaActualizar}
                            onChange={(e) => {
                                setFechaVacunaActualizar(e.target.value);
                            }}
                        />
                        {erroresActualizar.fechaVacuna && (
                        <div className="alert alert-danger bg-transparent border-0 text-danger m-0 p-0">
                          {erroresActualizar.fechaVacuna}
                        </div>
                      )}
                    </Form.Group>

                    <Form.Group controlId="formNombre">
                        <Form.Label>Observaciones</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ingrese sus observaciones"
                            name="nombre"
                            value={observacionesActualizar}
                            onChange={(e) => { setObservacionesActualizar(e.target.value) }}
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit" className="mt-3">
                        Actualizar
                    </Button>
                </Form></Modal.Body>
            </Modal>

            <Modal show={showModalAdjuntoBaja} onHide={() => cerrarModalAdjunto()} backdrop="static"
                keyboard={false} size="lg">
                <Modal.Header className="text-center" closeButton>
                    <Modal.Title>Adjunto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {imagenURL && <img className="img-fluid" src={imagenURL} alt="Imagen Cargada" />}
                    {pdfURL && <iframe src={pdfURL} width="100%" height="800px" />}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DirectorioColaborador